export const SectionHeading = ({
  chapter,
  eyebrow,
  title,
  description,
  align = "left",
  dark = false,
}) => {
  const centered = align === "center";
  return (
    <div className={`max-w-2xl ${centered ? "mx-auto text-center" : ""}`}>
      {chapter && (
        <p
          className={`mb-3 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.2em] ${
            centered ? "justify-center" : ""
          } ${dark ? "text-brand-amber" : "text-brand-green"}`}
        >
          <span className={`h-px w-8 ${dark ? "bg-brand-amber" : "bg-brand-green"}`} aria-hidden="true" />
          {eyebrow ? `${chapter} — ${eyebrow}` : chapter}
          {centered && <span className={`h-px w-8 ${dark ? "bg-brand-amber" : "bg-brand-green"}`} aria-hidden="true" />}
        </p>
      )}
      <h2
        className={`font-display text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-[2.75rem] lg:leading-[1.1] ${
          dark ? "text-white" : "text-brand-ink"
        }`}
      >
        {title}
      </h2>
      {description && (
        <p className={`mt-4 text-base leading-relaxed sm:text-lg ${dark ? "text-slate-300" : "text-brand-muted"}`}>
          {description}
        </p>
      )}
    </div>
  );
};
